import Bottombar from "@/components/bottombar"
import Button from "@/components/button"
import {
  Sheet,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet"
import { Textarea } from "@/components/ui/textarea"
import { useState, useEffect } from "react"

export interface ParamRemarksSheetProps {
  open: boolean
  initialRemark?: string
  onOpenChange: (open: boolean) => void
  onSave: (remark: string) => void
}

/**
 * Simple remarks sheet for Packaging V2
 * Used when user clicks on error flag for out-of-range or incorrect values
 */
export default function ParamRemarksSheet({
  open,
  initialRemark = "",
  onOpenChange,
  onSave,
}: ParamRemarksSheetProps) {
  const [remark, setRemark] = useState(initialRemark)

  useEffect(() => {
    if (open) {
      setRemark(initialRemark)
    }
  }, [open, initialRemark])

  function handleChangeRemark(value: string) {
    setRemark(value)
  }

  function handleSubmit() {
    if (remark.trim().length > 0) {
      onSave(remark.trim())
      onOpenChange(false)
    }
  }

  function handleClose() {
    onOpenChange(false)
  }

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" title="Fill remarks">
        <SheetHeader className="pb-0">
          <SheetTitle className="font-semibold text-xl text-button-black">
            Fill Remarks
          </SheetTitle>
        </SheetHeader>

        <div className="px-4 pb-8">
          <Textarea
            className="mt-6"
            placeholder="Describe the issue and action taken"
            value={remark}
            onChange={handleChangeRemark}
          />
        </div>

        <SheetFooter className="p-0">
          <Bottombar className="bg-white flex gap-4">
            <Button variant="outline" onClick={handleClose}>
              Back
            </Button>
            <Button
              className="grow"
              disabled={remark.trim().length === 0}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Bottombar>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  )
}
